module.exports = __webpack_public_path__ + "static/media/iot.1df001d3.svg";